const getters = {
  token: state => state.user.token,
  dict: (state) => state.dict.dict,
};
export default getters;
